module.exports = __webpack_public_path__ + "img/invite-rate.75470f24.svg";